import { DocumentFilterParams, DocumentStatus } from '@taxora-shared-common/util';

export class LoadMonths {
  static readonly type = '[AccountantDocuments] LoadMonths';
  constructor(
    public relationshipId: number,
    public organizationId: number,
    public filters?: Omit<DocumentFilterParams, 'year' | 'month' | 'page' | 'limit'>,
  ) {}
}

export class LoadDocuments {
  static readonly type = '[AccountantDocuments] LoadDocuments';
  constructor(
    public relationshipId: number,
    public organizationId: number,
    public year: number | null,
    public month: number | null,
    public filters?: DocumentFilterParams,
  ) {}
}

export class LoadDocument {
  static readonly type = '[AccountantDocuments] LoadDocument';
  constructor(public id: number) {}
}

export class UpdateStatus {
  static readonly type = '[AccountantDocuments] UpdateStatus';
  constructor(
    public id: number,
    public status: DocumentStatus,
  ) {}
}

export class CreateClarification {
  static readonly type = '[AccountantDocuments] CreateClarification';
  constructor(
    public id: number,
    public message: string,
  ) {}
}

export class ExportMonth {
  static readonly type = '[AccountantDocuments] ExportMonth';
  constructor(
    public relationshipId: number,
    public organizationId: number,
    public year: number,
    public month: number,
  ) {}
}

export class DownloadMonth {
  static readonly type = '[AccountantDocuments] DownloadMonth';
  constructor(
    public relationshipId: number,
    public organizationId: number,
    public year: number,
    public month: number,
  ) {}
}

export class OpenDrawer {
  static readonly type = '[AccountantDocuments] OpenDrawer';
  constructor(public id: number) {}
}

export class CloseDrawer {
  static readonly type = '[AccountantDocuments] CloseDrawer';
}

export class ResetDocuments {
  static readonly type = '[AccountantDocuments] ResetDocuments';
}
